import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { Widowhood as WidowhoodVM } from 'mutation/view-models/registration-widowhood';
import { FormikTouched, FormikErrors } from 'formik';
import { DateTime } from 'luxon';

interface ItalianState {
  values?: WidowhoodVM | null;
  onChange: (key: keyof WidowhoodVM, value: WidowhoodVM[keyof WidowhoodVM]) => void;
  errors?: FormikErrors<WidowhoodVM>;
  touched?: FormikTouched<WidowhoodVM>;
  fromDate?: DateTime | null;
}

const ItalianStateComponent = ({
  values,
  onChange,
  errors,
  touched,
  fromDate,
}: ItalianState): React.ReactElement => {
  return (
    <Grid item container spacing={1}>
      <Grid item xs={12} md={8}>
        <MunicipalityList
          required
          label={'Comune'}
          aria-label="Comune"
          value={values?.municipality || null}
          onChange={(element) => {
            onChange('municipality', element);
          }}
          fromDate={fromDate}
          error={Boolean(errors?.municipality) && touched?.municipality}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Provincia"
          id="province"
          name="province"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          value={values?.municipality?.province || ''}
          disabled
        />
      </Grid>
      {/* <Grid item xs={12} md={10}>
        <PmiTextField
          aria-label="Località"
          label="Località"
          id="locality"
          name="locality"
          fullWidth
          type="text"
          inputProps={{
            maxLength: '120',
          }}
          variant="outlined"
          value={values?.locality}
          onChange={(event) => onChange('locality', event.target.value)}
        />
      </Grid> */}
    </Grid>
  );
};

ItalianStateComponent.displayName = 'Italian State component';

const ItalianState = memo(ItalianStateComponent);

export default ItalianState;
